import { ISymbolsHandler } from '../../getSymbolsChecks.types';

export const handlerEscapedText: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;

  if (text[index + 1] === '`' && text[index + 2] === '`') {
    symbolMatches['```'].push({
      start: index,
      end: index + 3,
    });
  }
};
